import { Address } from '@thirdweb-dev/sdk';
import Contracts from '@steerprotocol/contracts/deployments/mode.json';
import { useContract } from '@thirdweb-dev/react';
import { useAsync } from 'react-use';

export function useVaultBalances(vaultAddress: Address | undefined | null) {
  const { contract } = useContract(
    Contracts.contracts.SteerPeriphery.address,
    Contracts.contracts.SteerPeriphery.abi
  );

  const { value, loading } = useAsync(async () => {
    if (!contract || !vaultAddress) {
      return;
    }

    try {
      const res =
        // @ts-ignore
        await contract.contractWrapper.writeContract.callStatic.vaultBalancesByAddressWithFees(
          vaultAddress
        );

      return res;
    } catch (e) {
      console.error(e);
    }
  }, [contract, vaultAddress]);

  return {
    data: value,
    isLoading: loading
  };
}
